/* eslint-disable */
import { noExponent } from '../utils/numbers';
import { omitDefault } from '@cosmjs/amino';
import { GenericAuthorization } from 'cosmjs-types/cosmos/authz/v1beta1/authz';
import { fromJsonTimestamp } from 'cosmjs-types/helpers';
// import { AminoTypes, createAuthzAminoConverters } from '@cosmjs/stargate';

// const aminoTypes = new AminoTypes(createAuthzAminoConverters());
const LocalGenericAuthorization = {
    typeUrl: '/cosmos.authz.v1beta1.GenericAuthorization',
    toAmino: ({
        msg,
    }) => ({
        msg,
    }),
    fromAmino: ({
        msg,
    }) => ({
        msg,
    }),
};

const MsgGrant = {
    typeUrl: '/cosmos.authz.v1beta1.MsgGrant',
    toAmino: ({
        authorization,
        expiration,
    }) => ({
        authorization: {
            type: "cosmos-sdk/GenericAuthorization",
            value: LocalGenericAuthorization.toAmino(authorization.value)
        },
        expiration: expiration || undefined,
    }),
    fromAmino: ({
        authorization,
        expiration,
    }) => ({
        authorization: {
            typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
            value: new Uint8Array(GenericAuthorization.encode(
                GenericAuthorization.fromPartial(LocalGenericAuthorization.fromAmino(authorization.value))).finish()),
        },
        expiration: fromJsonTimestamp(expiration),
    }),
};

export const customAminoTypes = {
    '/ibc.applications.transfer.v1.MsgTransfer': {
        aminoType: 'cosmos-sdk/MsgTransfer',
        toAmino: ({
            source_port,
            source_channel,
            token,
            sender,
            receiver,
            timeout_height,
            timeout_timestamp,
        }) => {
            const obj = {
                source_port: source_port,
                source_channel: source_channel,
                token: token,
                sender: sender,
                receiver: receiver,
                timeout_height: timeout_height
                    ? {
                        revision_height: omitDefault(timeout_height.revision_height)?.toString(),
                        revision_number: omitDefault(timeout_height.revision_height)?.toString(),
                    }
                    : {},
            };

            if (timeout_timestamp) {
                obj.timeout_timestamp = omitDefault(timeout_timestamp)?.toString();
            }

            return obj;
        },
        fromAmino: ({
            source_port,
            source_channel,
            token,
            sender,
            receiver,
            timeout_height,
            timeout_timestamp,
        }) => ({
            sourcePort: source_port,
            sourceChannel: source_channel,
            token: token,
            sender: sender,
            receiver: receiver,
            timeoutHeight: timeout_height
                ? {
                    revisionHeight: BigInt(timeout_height.revision_height || '0'),
                    revisionNumber: BigInt(timeout_height.revision_number || '0'),
                }
                : undefined,
            timeoutTimestamp: BigInt(timeout_timestamp || '0'),
        }),
    },
    '/cosmos.bank.v1beta1.MsgSend': {
        aminoType: 'cosmos-sdk/MsgSend',
        toAmino: ({
            fromAddress,
            toAddress,
            amount,
        }) => ({
            from_address: fromAddress,
            to_address: toAddress,
            amount: [...amount],
        }),
        fromAmino: ({
            from_address,
            to_address,
            amount,
        }) => ({
            fromAddress: from_address,
            toAddress: to_address,
            amount: [...amount],
        }),
    },
    '/cosmos.authz.v1beta1.MsgGrant': {
        aminoType: 'cosmos-sdk/MsgGrant',
        toAmino: ({
            granter,
            grantee,
            grant,
        }) => ({
            granter: granter,
            grantee: grantee,
            grant: MsgGrant.toAmino(grant),
        }),
        fromAmino: ({
            granter,
            grantee,
            grant,
        }) => ({
            granter: granter,
            grantee: grantee,
            grant: MsgGrant.fromAmino(grant),
        }),
    },
    '/cosmos.authz.v1beta1.GenericAuthorization': {
        aminoType: 'cosmos-sdk/GenericAuthorization',
        toAmino: ({
            value,
        }) => ({
            value: value,
        }),
        fromAmino: ({
            value,
        }) => ({
            value: value,
        }),
    },
    // '/cosmos.authz.v1beta1.MsgGrant': {
    //     aminoType: 'cosmos-sdk/MsgGrant',
    //     toAmino: ({
    //         granter,
    //         grantee,
    //         grant,
    //     }) => aminoTypes.toAmino({
    //         typeUrl: '/cosmos.authz.v1beta1.MsgGrant',
    //         value: {
    //             granter,
    //             grantee,
    //             grant,
    //         },
    //     }),
    //     fromAmino: ({
    //         granter,
    //         grantee,
    //         grant,
    //     }) => aminoTypes.fromAmino({
    //         type: 'cosmos-sdk/MsgGrant',
    //         value: {
    //             granter,
    //             grantee,
    //             grant,
    //         },
    //     }),
    // },
    '/OmniFlix.onft.v1beta1.MsgCreateDenom': {
        aminoType: 'OmniFlix/onft/MsgCreateDenom',
        toAmino: ({
            id,
            symbol,
            name,
            description,
            preview_uri,
            schema,
            sender,
            creation_fee,
            royalty_receivers,
        }) => {
            const obj = {
                id,
                symbol,
                sender,
                creation_fee,
            };

            if (name) {
                obj.name = name;
            }
            if (description) {
                obj.description = description;
            }
            if (preview_uri || preview_uri === '') {
                obj.preview_uri = preview_uri;
            }
            if (schema) {
                obj.schema = schema;
            }
            if (royalty_receivers) {
                obj.royalty_receivers = royalty_receivers;
            }

            return obj;
        },
        fromAmino: ({
            id,
            symbol,
            name,
            description,
            preview_uri,
            schema,
            sender,
            creation_fee,
            royalty_receivers,
        }) => {
            const obj = {
                id,
                symbol,
                sender,
                creationFee: creation_fee,
            };

            if (name) {
                obj.name = name;
            }
            if (description) {
                obj.description = description;
            }
            if (preview_uri) {
                obj.previewUri = preview_uri;
            }
            if (schema) {
                obj.schema = schema;
            }
            if (royalty_receivers) {
                obj.royaltyReceivers = royalty_receivers;
            }

            return obj;
        },
    },
    '/OmniFlix.onft.v1beta1.MsgUpdateDenom': {
        aminoType: 'OmniFlix/onft/MsgUpdateDenom',
        toAmino: ({
            id,
            name,
            description,
            preview_uri,
            sender,
            royalty_receivers,
        }) => {
            const obj = {
                id,
                sender,
            };

            if (name) {
                obj.name = name;
            }
            if (description) {
                obj.description = description;
            }
            if (preview_uri || preview_uri === '') {
                obj.preview_uri = preview_uri;
            }
            if (royalty_receivers) {
                obj.royalty_receivers = royalty_receivers;
            }

            return obj;
        },
        fromAmino: ({
            id,
            name,
            description,
            preview_uri,
            sender,
            royalty_receivers,
        }) => {
            const obj = {
                id,
                sender,
            };

            if (name) {
                obj.name = name;
            }
            if (description) {
                obj.description = description;
            }
            if (preview_uri) {
                obj.previewUri = preview_uri;
            }
            if (royalty_receivers) {
                obj.royaltyReceivers = royalty_receivers;
            }

            return obj;
        },
    },
    '/OmniFlix.onft.v1beta1.MsgTransferDenom': {
        aminoType: 'OmniFlix/onft/MsgTransferDenom',
        toAmino: ({
            id,
            sender,
            recipient,
        }) => {
            return {
                id,
                sender,
                recipient,
            };
        },
        fromAmino: ({
            id,
            sender,
            recipient,
        }) => {
            return {
                id,
                sender,
                recipient,
            };
        },
    },
    '/OmniFlix.onft.v1beta1.MsgMintONFT': {
        aminoType: 'OmniFlix/onft/MsgMintONFT',
        toAmino: ({
            id,
            denom_id,
            metadata,
            data,
            transferable,
            extensible,
            nsfw,
            royalty_share,
            sender,
            recipient,
        }) => {
            const obj = {
                id,
                denom_id,
                metadata: metadata || {},
                data: data || {},
                royalty_share: royalty_share || '0.000000000000000000',
                sender,
                recipient,
            };

            if (transferable) {
                obj.transferable = transferable;
            }
            if (extensible) {
                obj.extensible = extensible;
            }
            if (nsfw) {
                obj.nsfw = nsfw;
            }
            if (metadata) {
                const data = {};
                if (metadata.name) {
                    data.name = metadata.name;
                }
                if (metadata.description) {
                    data.description = metadata.description;
                }
                if (metadata.preview_uri) {
                    data.preview_uri = metadata.preview_uri;
                }
                if (metadata.media_uri) {
                    data.media_uri = metadata.media_uri;
                }

                obj.metadata = data;
            }

            return obj;
        },
        fromAmino: ({
            id,
            denom_id,
            metadata,
            data,
            transferable,
            extensible,
            nsfw,
            royalty_share,
            sender,
            recipient,
        }) => {
            const obj = {
                id,
                denomId: denom_id,
                metadata: metadata || {},
                data: data || {},
                sender,
                recipient,
                royaltyShare: royalty_share || '0',
            };

            if (transferable) {
                obj.transferable = transferable;
            }
            if (extensible) {
                obj.extensible = extensible;
            }
            if (nsfw) {
                obj.nsfw = nsfw;
            }
            if (metadata) {
                const data = {};
                if (metadata.name) {
                    data.name = metadata.name;
                }
                if (metadata.description) {
                    data.description = metadata.description;
                }
                if (metadata.preview_uri) {
                    data.previewUri = metadata.preview_uri;
                }
                if (metadata.media_uri) {
                    data.mediaUri = metadata.media_uri;
                }

                obj.metadata = data;
            }

            return obj;
        },
    },
    '/OmniFlix.onft.v1beta1.MsgTransferONFT': {
        aminoType: 'OmniFlix/onft/MsgTransferONFT',
        toAmino: ({
            id,
            denom_id,
            sender,
            recipient,
        }) => {
            return {
                id,
                denom_id,
                sender,
                recipient,
            };
        },
        fromAmino: ({
            id,
            denom_id,
            sender,
            recipient,
        }) => {
            return {
                id,
                denomId: denom_id,
                sender,
                recipient,
            };
        },
    },
    '/OmniFlix.onft.v1beta1.MsgBurnONFT': {
        aminoType: 'OmniFlix/onft/MsgBurnONFT',
        toAmino: ({
            id,
            denom_id,
            sender,
        }) => {
            return {
                id,
                denom_id,
                sender,
            };
        },
        fromAmino: ({
            id,
            denom_id,
            sender,
        }) => {
            return {
                id,
                denomId: denom_id,
                sender,
            };
        },
    },
    '/OmniFlix.marketplace.v1beta1.MsgListNFT': {
        aminoType: 'OmniFlix/marketplace/MsgListNFT',
        toAmino: ({
            id,
            nft_id,
            denom_id,
            price,
            owner,
            split_shares,
        }) => {
            const obj = {
                id,
                nft_id,
                denom_id,
                price: price || undefined,
                owner,
            };

            if (split_shares) {
                obj.split_shares = split_shares;
            }

            return obj;
        },
        fromAmino: ({
            id,
            nft_id,
            denom_id,
            price,
            owner,
            split_shares,
        }) => {
            const obj = {
                id: id,
                nftId: nft_id,
                denomId: denom_id,
                price,
                owner,
            };

            if (split_shares) {
                obj.splitShares = split_shares;
            }

            return obj;
        },
    },
    '/OmniFlix.marketplace.v1beta1.MsgEditListing': {
        aminoType: 'OmniFlix/marketplace/MsgEditListing',
        toAmino: ({
            id,
            price,
            owner,
        }) => {
            return {
                id,
                price: price || undefined,
                owner,
            };
        },
        fromAmino: ({
            id,
            price,
            owner,
        }) => {
            return {
                id,
                price: price || undefined,
                owner,
            };
        },
    },
    '/OmniFlix.marketplace.v1beta1.MsgDeListNFT': {
        aminoType: 'OmniFlix/marketplace/MsgDeListNFT',
        toAmino: ({
            id,
            owner,
        }) => {
            return {
                id,
                owner,
            };
        },
        fromAmino: ({
            id,
            owner,
        }) => {
            return {
                id,
                owner,
            };
        },
    },
    '/OmniFlix.marketplace.v1beta1.MsgBuyNFT': {
        aminoType: 'OmniFlix/marketplace/MsgBuyNFT',
        toAmino: ({
            id,
            price,
            buyer,
        }) => {
            return {
                id,
                price: price || undefined,
                buyer,
            };
        },
        fromAmino: ({
            id,
            price,
            buyer,
        }) => {
            return {
                id,
                price: price || undefined,
                buyer,
            };
        },
    },
    '/OmniFlix.marketplace.v1beta1.MsgCreateAuction': {
        aminoType: 'OmniFlix/marketplace/MsgCreateAuction',
        toAmino: ({
            nft_id,
            denom_id,
            start_time,
            start_price,
            duration,
            increment_percentage,
            whitelist_accounts,
            split_shares,
            owner,
        }) => {
            const obj = {
                nft_id,
                denom_id,
                start_time: start_time || undefined,
                start_price: start_price || undefined,
                increment_percentage: increment_percentage || '0',
                owner,
            };

            if (duration) {
                obj.duration = duration;
            }
            if (whitelist_accounts) {
                obj.whitelist_accounts = whitelist_accounts;
            }
            if (split_shares) {
                obj.split_shares = split_shares;
            }

            return obj;
        },
        fromAmino: ({
            nft_id,
            denom_id,
            start_time,
            start_price,
            duration,
            increment_percentage,
            whitelist_accounts,
            split_shares,
            owner,
        }) => {
            const obj = {
                nftId: nft_id,
                denomId: denom_id,
                startTime: start_time || undefined,
                startPrice: start_price || undefined,
                incrementPercentage: increment_percentage || '0',
                owner,
            };

            if (duration) {
                const data = {
                    seconds: 0,
                };
                let duration1 = duration;
                duration1 = duration1 / (10 ** 9);
                duration1 = noExponent(duration1);
                data.seconds = duration1;
                obj.duration = data;
            }
            if (whitelist_accounts) {
                obj.whitelistAccounts = whitelist_accounts;
            }
            if (split_shares) {
                obj.splitShares = split_shares;
            }

            return obj;
        },
    },
    '/OmniFlix.marketplace.v1beta1.MsgCancelAuction': {
        aminoType: 'OmniFlix/marketplace/MsgCancelAuction',
        toAmino: ({
            auction_id,
            owner,
        }) => {
            return {
                auction_id,
                owner,
            };
        },
        fromAmino: ({
            auction_id,
            owner,
        }) => {
            return {
                auctionId: auction_id,
                owner,
            };
        },
    },
    '/OmniFlix.marketplace.v1beta1.MsgPlaceBid': {
        aminoType: 'OmniFlix/marketplace/MsgPlaceBid',
        toAmino: ({
            auction_id,
            amount,
            bidder,
        }) => {
            return {
                auction_id,
                amount: amount || undefined,
                bidder,
            };
        },
        fromAmino: ({
            auction_id,
            amount,
            bidder,
        }) => {
            return {
                auctionId: auction_id,
                amount: amount || undefined,
                bidder,
            };
        },
    },
    '/OmniFlix.itc.v1.MsgCreateCampaign': {
        aminoType: 'OmniFlix/itc/MsgCreateCampaign',
        toAmino: ({
            name,
            description,
            interaction,
            claim_type,
            nft_denom_id,
            tokens_per_claim,
            max_allowed_claims,
            deposit,
            nft_mint_details,
            start_time,
            duration,
            distribution,
            creator,
            creation_fee,
        }) => {
            const obj = {
                name,
                description: description || '',
                nft_denom_id: nft_denom_id || '',
                start_time: start_time || undefined,
                creator: creator || '',
                creation_fee: creation_fee || undefined,
            };

            if (claim_type) {
                obj.claim_type = claim_type;
            }
            if (interaction) {
                obj.interaction = interaction;
            }
            if (duration) {
                obj.duration = duration;
            }
            if (tokens_per_claim) {
                obj.tokens_per_claim = tokens_per_claim;
            }
            if (max_allowed_claims) {
                obj.max_allowed_claims = max_allowed_claims;
            }
            if (deposit) {
                obj.deposit = deposit;
            }
            if (nft_mint_details) {
                const data = {};
                if (nft_mint_details.name) {
                    data.name = nft_mint_details.name;
                }
                if (nft_mint_details.denom_id) {
                    data.denom_id = nft_mint_details.denom_id;
                }
                if (nft_mint_details.description) {
                    data.description = nft_mint_details.description;
                }
                if (nft_mint_details.media_uri) {
                    data.media_uri = nft_mint_details.media_uri;
                }
                if (nft_mint_details.preview_uri) {
                    data.preview_uri = nft_mint_details.preview_uri;
                }
                if (nft_mint_details.data) {
                    data.data = nft_mint_details.data;
                }
                if (nft_mint_details.royalty_share) {
                    data.royalty_share = nft_mint_details.royalty_share;
                }
                if (nft_mint_details.nsfw) {
                    data.nsfw = nft_mint_details.nsfw;
                }
                if (nft_mint_details.extensible) {
                    data.extensible = nft_mint_details.extensible;
                }
                if (nft_mint_details.transferable) {
                    data.transferable = nft_mint_details.transferable;
                }
                if (nft_mint_details.name_delimiter) {
                    data.name_delimiter = nft_mint_details.name_delimiter;
                }
                if (nft_mint_details.start_index) {
                    data.start_index = nft_mint_details.start_index;
                }

                obj.nft_mint_details = data;
            }
            if (distribution) {
                const data = {};
                if (distribution.type) {
                    data.type = distribution.type;
                }
                if (distribution.stream_duration) {
                    data.stream_duration = distribution.stream_duration;
                }

                obj.distribution = data;
            }

            return obj;
        },
        fromAmino: ({
            name,
            description,
            interaction,
            claim_type,
            nft_denom_id,
            tokens_per_claim,
            max_allowed_claims,
            deposit,
            nft_mint_details,
            start_time,
            duration,
            distribution,
            creator,
            creation_fee,
        }) => {
            const obj = {
                name,
                description: description || '',
                nftDenomId: nft_denom_id || '',
                startTime: start_time || undefined,
                creator: creator || '',
                creationFee: creation_fee || undefined,
            };

            if (claim_type) {
                obj.claimType = claim_type;
            }
            if (interaction) {
                obj.interaction = interaction;
            }
            if (duration) {
                const data = {
                    seconds: 0,
                };
                let duration1 = duration;
                duration1 = duration1 / (10 ** 9);
                duration1 = noExponent(duration1);
                data.seconds = duration1;
                obj.duration = data;
            }
            if (tokens_per_claim) {
                obj.tokensPerClaim = tokens_per_claim;
            }
            if (max_allowed_claims) {
                obj.maxAllowedClaims = max_allowed_claims;
            }
            if (deposit) {
                obj.deposit = deposit;
            }
            if (nft_mint_details) {
                const data = {};
                if (nft_mint_details.name) {
                    data.name = nft_mint_details.name;
                }
                if (nft_mint_details.denom_id) {
                    data.denomId = nft_mint_details.denom_id;
                }
                if (nft_mint_details.description) {
                    data.description = nft_mint_details.description;
                }
                if (nft_mint_details.media_uri) {
                    data.mediaUri = nft_mint_details.media_uri;
                }
                if (nft_mint_details.preview_uri) {
                    data.previewUri = nft_mint_details.preview_uri;
                }
                if (nft_mint_details.data) {
                    data.data = nft_mint_details.data;
                }
                if (nft_mint_details.royalty_share) {
                    data.royaltyShare = String(nft_mint_details.royalty_share);
                } else {
                    data.royaltyShare = '0';
                }
                if (nft_mint_details.nsfw) {
                    data.nsfw = nft_mint_details.nsfw;
                }
                if (nft_mint_details.extensible) {
                    data.extensible = nft_mint_details.extensible;
                }
                if (nft_mint_details.transferable) {
                    data.transferable = nft_mint_details.transferable;
                }
                if (nft_mint_details.name_delimiter) {
                    data.nameDelimiter = nft_mint_details.name_delimiter;
                }
                if (nft_mint_details.start_index) {
                    data.startIndex = nft_mint_details.start_index;
                }

                obj.nftMintDetails = data;
            }
            if (distribution) {
                const data = {
                    streamDuration: {
                        seconds: 0,
                    },
                };

                if (distribution.type) {
                    data.type = distribution.type;
                }
                if (distribution.stream_duration) {
                    let duration = Number(distribution.stream_duration) / (10 ** 9);
                    duration = noExponent(duration);
                    data.streamDuration.seconds = duration;
                } else {
                    data.streamDuration.seconds = 0;
                }

                obj.distribution = data;
            }

            return obj;
        },
    },
    '/OmniFlix.itc.v1.MsgCancelCampaign': {
        aminoType: 'OmniFlix/itc/MsgCancelCampaign',
        toAmino: ({
            campaign_id,
            creator,
        }) => {
            return {
                campaign_id,
                creator,
            };
        },
        fromAmino: ({
            campaign_id,
            creator,
        }) => {
            return {
                campaignId: campaign_id,
                creator,
            };
        },
    },
    '/OmniFlix.itc.v1.MsgClaim': {
        aminoType: 'OmniFlix/itc/MsgClaim',
        toAmino: ({
            campaign_id,
            nft_id,
            interaction,
            claimer,
        }) => {
            const obj = {
                campaign_id,
                nft_id,
                claimer,
            }
            if (interaction) {
                obj.interaction = interaction;
            }

            return obj;
        },
        fromAmino: ({
            campaign_id,
            nft_id,
            interaction,
            claimer,
        }) => {
            const obj = {
                campaignId: campaign_id,
                nftId: nft_id,
                claimer,
            }
            if (interaction) {
                obj.interaction = interaction;
            }

            return obj;
        },
    },
    '/OmniFlix.itc.v1.MsgDepositCampaign': {
        aminoType: 'OmniFlix/itc/MsgDepositCampaign',
        toAmino: ({
            campaign_id,
            amount,
            depositor,
        }) => {
            return {
                campaign_id,
                amount: amount || undefined,
                depositor,
            };
        },
        fromAmino: ({
            campaign_id,
            amount,
            depositor,
        }) => {
            return {
                campaignId: campaign_id,
                amount: amount || undefined,
                depositor,
            };
        },
    },
    '/OmniFlix.streampay.v1.MsgStreamSend': {
        aminoType: 'OmniFlix/streampay/MsgStreamSend',
        toAmino: ({
            sender,
            recipient,
            amount,
            duration,
            stream_type,
            periods,
            cancellable,
            fee,
        }) => {
            const obj = {
                sender,
                recipient,
                amount: amount || undefined,
                cancellable: cancellable || false,
                fee: fee || undefined,
            };

            if (duration) {
                obj.duration = duration;
            }
            if (stream_type) {
                obj.stream_type = stream_type;
            }
            if (periods) {
                obj.periods = periods;
            }

            return obj;
        },
        fromAmino: ({
            sender,
            recipient,
            amount,
            duration,
            stream_type,
            periods,
            cancellable,
            fee,
        }) => {
            const obj = {
                sender,
                recipient,
                amount: amount || undefined,
                cancellable: cancellable || false,
                fee: fee || undefined,
            };

            if (duration) {
                obj.duration = duration;
            }
            if (stream_type) {
                obj.streamType = stream_type;
            }
            if (periods) {
                obj.periods = periods;
            }

            return obj;
        },
    },
    '/OmniFlix.streampay.v1.MsgStopStream': {
        aminoType: 'OmniFlix/streampay/MsgStopStream',
        toAmino: ({
            stream_id,
            sender,
        }) => {
            return {
                stream_id,
                sender,
            };
        },
        fromAmino: ({
            stream_id,
            sender,
        }) => {
            return {
                streamId: stream_id,
                sender,
            };
        },
    },
    '/OmniFlix.streampay.v1.MsgClaimStreamedAmount': {
        aminoType: 'OmniFlix/streampay/MsgClaimStreamedAmount',
        toAmino: ({
            stream_id,
            claimer,
        }) => {
            return {
                stream_id,
                claimer,
            };
        },
        fromAmino: ({
            stream_id,
            claimer,
        }) => {
            return {
                streamId: stream_id,
                claimer,
            };
        },
    },
    // Media Node
    "/OmniFlix.medianode.v1beta1.MsgLeaseMediaNode": {
        aminoType: "OmniFlix/lease-medianode",
        toAmino: ({
            media_node_id,
            lease_hours,
            amount,
            sender,
        }) => {
            return {
                media_node_id,
                lease_hours,
                amount: amount || undefined,
                sender,
            };
        },
        fromAmino: ({
            media_node_id,
            lease_hours,
            amount,
            sender,
        }) => {
            return {
                mediaNodeId: media_node_id,
                leaseHours: lease_hours,
                amount: amount || undefined,
                sender,
            };
        },
    },
    "/OmniFlix.medianode.v1beta1.MsgCancelLease": {
        aminoType: "OmniFlix/cancel-medianode-lease",
        toAmino: ({
            media_node_id,
            sender,
        }) => {
            return {
                media_node_id,
                sender,
            };
        },
        fromAmino: ({
            media_node_id,
            sender,
        }) => {
            return {
                mediaNodeId: media_node_id,
                sender,
            };
        },
    },
    "/OmniFlix.medianode.v1beta1.MsgExtendLease": {
        aminoType: "OmniFlix/extend-medianode-lease",
        toAmino: ({
            media_node_id,
            lease_hours,
            amount,
            sender,
        }) => {
            return {
                media_node_id,
                lease_hours,
                amount: amount || undefined,
                sender,
            };
        },
        fromAmino: ({
            media_node_id,
            lease_hours,
            amount,
            sender,
        }) => {
            return {
                mediaNodeId: media_node_id,
                leaseHours: lease_hours,
                amount: amount || undefined,
                sender,
            };
        },
    },
    "/OmniFlix.medianode.v1beta1.MsgRegisterMediaNode": {
        aminoType: "OmniFlix/register-medianode",
        toAmino: ({
            id,
            url,
            hardware_specs,
            price_per_hour,
            deposit,
            sender,
            info,
        }) => {
            const obj = {
                id,
                url,
                price_per_hour: price_per_hour || undefined,
                sender,
            };

            if (deposit) {
                obj.deposit = deposit;
            }
            if (info) {
                obj.info = {};
                if (info.moniker) {
                    obj.info.moniker = info.moniker;
                }
                if (info.description) {
                    obj.info.description = info.description;
                }
                if (info.contact) {
                    obj.info.contact = info.contact;
                }
            }
            if (hardware_specs) {
                obj.hardware_specs = {};
                if (hardware_specs.cpus) {
                    obj.hardware_specs.cpus = hardware_specs.cpus;
                }
                if (hardware_specs.ram_in_gb) {
                    obj.hardware_specs.ram_in_gb = hardware_specs.ram_in_gb;
                }
                if (hardware_specs.storage_in_gb) {
                    obj.hardware_specs.storage_in_gb = hardware_specs.storage_in_gb;
                }
            }

            return obj;
        },
        fromAmino: ({
            id,
            url,
            hardware_specs,
            price_per_hour,
            deposit,
            sender,
            info,
        }) => {
            const obj = {
                id,
                url,
                pricePerHour: price_per_hour || undefined,
                sender,
            };

            if (deposit) {
                obj.deposit = deposit;
            }
            if (info) {
                obj.info = {};
                if (info.moniker) {
                    obj.info.moniker = info.moniker;
                }
                if (info.description) {
                    obj.info.description = info.description;
                }
                if (info.contact) {
                    obj.info.contact = info.contact;
                }
            }
            if (hardware_specs) {
                obj.hardwareSpecs = {};
                if (hardware_specs.cpus) {
                    obj.hardwareSpecs.cpus = hardware_specs.cpus;
                }
                if (hardware_specs.ram_in_gb) {
                    obj.hardwareSpecs.ramInGb = hardware_specs.ram_in_gb;
                }
                if (hardware_specs.storage_in_gb) {
                    obj.hardwareSpecs.storageInGb = hardware_specs.storage_in_gb;
                }
            }

            return obj;
        },
    },
    "/OmniFlix.medianode.v1beta1.MsgUpdateMediaNode": {
        aminoType: "OmniFlix/update-medianode",
        toAmino: ({
            id,
            hardware_specs,
            price_per_hour,
            sender,
            info,
        }) => {
            const obj = {
                id,
                sender,
            };

            if (price_per_hour) {
                obj.price_per_hour = price_per_hour;
            }
            if (info) {
                obj.info = {};
                if (info.moniker) {
                    obj.info.moniker = info.moniker;
                }
                if (info.description) {
                    obj.info.description = info.description;
                }
                if (info.contact) {
                    obj.info.contact = info.contact;
                }
            }
            if (hardware_specs) {
                obj.hardware_specs = {};
                if (hardware_specs.cpus) {
                    obj.hardware_specs.cpus = hardware_specs.cpus;
                }
                if (hardware_specs.ram_in_gb) {
                    obj.hardware_specs.ram_in_gb = hardware_specs.ram_in_gb;
                }
                if (hardware_specs.storage_in_gb) {
                    obj.hardware_specs.storage_in_gb = hardware_specs.storage_in_gb;
                }
            }

            return obj;
        },
        fromAmino: ({
            id,
            hardware_specs,
            price_per_hour,
            sender,
            info,
        }) => {
            const obj = {
                id,
                sender,
            };

            if (price_per_hour) {
                obj.pricePerHour = price_per_hour;
            }
            if (info) {
                obj.info = {};
                if (info.moniker) {
                    obj.info.moniker = info.moniker;
                }
                if (info.description) {
                    obj.info.description = info.description;
                }
                if (info.contact) {
                    obj.info.contact = info.contact;
                }
            }
            if (hardware_specs) {
                obj.hardwareSpecs = {};
                if (hardware_specs.cpus) {
                    obj.hardwareSpecs.cpus = hardware_specs.cpus;
                }
                if (hardware_specs.ram_in_gb) {
                    obj.hardwareSpecs.ramInGb = hardware_specs.ram_in_gb;
                }
                if (hardware_specs.storage_in_gb) {
                    obj.hardwareSpecs.storageInGb = hardware_specs.storage_in_gb;
                }
            }

            return obj;
        },
    },
    "/OmniFlix.medianode.v1beta1.MsgCloseMediaNode": {
        aminoType: "OmniFlix/close-medianode",
        toAmino: ({
            media_node_id,
            sender,
        }) => {
            return {
                media_node_id,
                sender,
            };
        },
        fromAmino: ({
            media_node_id,
            sender,
        }) => {
            return {
                mediaNodeId: media_node_id,
                sender,
            };
        },
    },
    "/OmniFlix.medianode.v1beta1.MsgDepositMediaNode": {
        aminoType: "OmniFlix/deposit-medianode",
        toAmino: ({
            media_node_id,
            amount,
            sender,
        }) => {
            return {
                media_node_id,
                amount: amount || undefined,
                sender,
            };
        },
        fromAmino: ({
            media_node_id,
            amount,
            sender,
        }) => {
            return {
                mediaNodeId: media_node_id,
                amount: amount || undefined,
                sender,
            };
        },
    },
};
